import BHBenefitRoutes from '@/lib/constants/bh_benefit_route_names';
import BhBenefits from '../../apps/bh_benefits/BhBenefits.vue';
import Generic from '../../apps/bh_benefits/Generic.vue';
import UpgradeFlow from '../../apps/bh_benefits/upgrade/UpgradeFlow.vue';
import ClientSpecific from '../../apps/bh_benefits/ClientSpecific.vue';
import SignUp from '../../apps/bh_benefits/SignUp.vue';

const bhBenefitsRoutes = [
  {
    path: '/bh-benefits',
    component: BhBenefits,
    children: [
      {
        name: BHBenefitRoutes.HOME,
        path: '/',
        component: Generic,
      },
      {
        name: BHBenefitRoutes.UPGRADE,
        path: 'upgrade',
        component: UpgradeFlow,
      },
      {
        path: ':slug',
        name: BHBenefitRoutes.SIGNUP,
        component: ClientSpecific,
      },
      {
        name: BHBenefitRoutes.YA_SIGNUP,
        path: ':slug/signup',
        component: SignUp,
        beforeEnter(to, from, next) {
          if (to.query.site === 'years_ahead') {
            next();
          } else {
            next({ name: BHBenefitRoutes.SIGNUP, params: { slug: to.params.slug }, query: to.query });
          }
        },
      },
    ],
  },
];

export default bhBenefitsRoutes;
